import { render } from "./TratamientoReporte.vue?vue&type=template&id=3c5adb56&scoped=true"
import script from "./TratamientoReporte.vue?vue&type=script&lang=js"
export * from "./TratamientoReporte.vue?vue&type=script&lang=js"

import "./TratamientoReporte.vue?vue&type=style&index=0&id=3c5adb56&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5adb56"]])

export default __exports__